var serviceBaseUrl = "";

if (process.env.NODE_ENV === "development") {
    //开发
    serviceBaseUrl = "https://wwwtest.yimidida.com/server/";
} else if (process.env.VUE_APP_BUILD_MODE === "develop") {
    //103
    serviceBaseUrl = "http://10.215.50.161:9090/";
} else if (process.env.VUE_APP_BUILD_MODE === "production") {
    //生产
    serviceBaseUrl = "https://www.yimidida.com/server/";
} else if (process.env.VUE_APP_BUILD_MODE === "test") {
    //测试
    serviceBaseUrl = "https://wwwtest.yimidida.com/server/";
}   else if (process.env.VUE_APP_BUILD_MODE === "pre") {
    //测试
    serviceBaseUrl = "https://pre-www.yimidida.com/server/";
}

export default serviceBaseUrl;
